import React, { useEffect, useState } from "react";
import { ValidateImg } from "../../utils/Utils";
import { useForm } from "react-hook-form";
import ViewImage from "../../myComponents/modals/ViewImage";
import { Badge, Card, Form, Label, Spinner } from "reactstrap";
import { BiEdit, BiMinus, BiPlus } from "react-icons/bi";
import ImageUpload from "../../myComponents/form/ImageUpload";
import Select from "react-select";
import { addHomeBannerAPI, getBannerEditAPI, getPhotoGalleryListAPI, statusUpdateBannerAPI } from "../../api/banner";
import MyDataTable from "../../myComponents/DataTable/MyDataTable";
import ConfirmModal from "../../myComponents/modals/ConfirmModal";
import { toast } from "react-toastify";
import { updateImgUploadStatusAPI } from "../../api/menu";
import { decrypt, encrypt, encryptFormData } from "../../utils/Encrypt";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import Required from "../../myComponents/validate/Required";
import useLogout from "../../hooks/useLogout";

const PhotoGallery = () => {
     const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mode, setMode] = useState("Add");
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);
  const userData = JSON.parse(localStorage.getItem("userDetail"));
  const IMAGE_BASE_URL = localStorage.getItem("IMAGE_BASE_URL");
  const [column, setColumn] = useState([
    {
      name: "Image Title",
      selector: (row) => row?.image_title,
      sortable: true,
    },
    {
      name: "Image Alt",
      selector: (row) => row?.image_alt,
      sortable: true,
    },
    {
      name: "Image Title Hindi",
      selector: (row) => row?.hn_image_title,
      sortable: true,
    },
    {
      name: "Image Alt Hindi",
      selector: (row) => row?.hn_image_alt,
      sortable: true,
    },
    {
      name: "Image",
      selector: (row) => (
        <div onClick={() => handleImageOpenPreview(`${IMAGE_BASE_URL}` + row?.banner_image)}>
          <img style={{ width: "50px" }} src={`${IMAGE_BASE_URL}` + row.banner_image} />
        </div>
      ),
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row.status ? "success" : "danger"}`}>{row.status ? "Active" : "InActive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
          <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
            {" "}
            <BiEdit />
          </Button>
        </div>
      ),
    },
  ]);
  // Modal Image Preview
  const [imageOpen, setImageOpen] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      image_url: null,
    },
  });
  const handleStatusUpdate = (row) => {
    setValue("id", row.id);
    setValue("status", row.status);
    setShowModal(true);
  };
  useEffect(() => {
    getBannerData();
  }, []);
  const getBannerData = () => {
    const data = {
      doc_type: "gallery",
    };
    getPhotoGalleryListAPI(data)
      .then((res) => {
        // decrypt data
        const status = decrypt(res.data.status);
        if (status === "success") {
          const decryptedResponse = decrypt(res.data.data.tableData);
          toast.success(res.data.message);
          setData(decryptedResponse);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setData([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleImageChange = (e, errorInput, url) => {
    const file = e.target.files[0];
    if (file) {
      ValidateImg(file, (isValid) => {
        if (isValid) {
          // Process the valid image
          const imageUrl = URL.createObjectURL(file); // Create blob URL
          setValue(url, imageUrl); // Set image URL to state
          setValue(errorInput, file);
          trigger(errorInput);
          // Clear previous errors (ensure it happens after state updates)
          setTimeout(() => {
            clearErrors(errorInput);
          }, 100);
        } else {
          // Handle the invalid file type
          setError(errorInput, {
            type: "manual",
            message: "Invalid file type. Only PNG, JPEG, and JPG files are allowed.",
          });
          console.error("Invalid file type. Only PNG, JPEG, and JPG files are allowed.");
          e.target.value = ""; // Clear the input
        }
      });
    } else {
      setValue(errorInput, "");
    }
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  const handleStatusChange = (selectedOption) => {
    setValue("status", selectedOption || "");
    trigger("status");
  };
  const onFormSubmit = async (data) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("image_alt", data.image_alt);
    formData.append("hn_image_alt", data.image_alt_hn);
    formData.append("banner_image", data.image);
    formData.append("image_title", data.image_title);
    formData.append("hn_image_title", data.image_title_hn);
    formData.append("status", data.status.value);
    formData.append("doc_type", "gallery");
    formData.append("module", "photo_gallery");
    const newFd = new FormData();

    if (mode == "Edit") {
      formData.append("id", watch("id"));
    }
    const encryptedData = await encryptFormData(formData);
    newFd.append("zero", encryptedData);
    if (watch("image_url") == null) {
      newFd.append("banner_image", data?.image[0]);
    } else {
      newFd.append("banner_image", data?.image);
    }
    if (mode === "Add") {
      addHomeBannerAPI(newFd)
        .then((res) => {
          const status = decrypt(res.data.status);
          if (status == "success") {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getBannerData();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === "failed") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    }
    if (mode === "Edit") {
      getBannerEditAPI(newFd)
        .then((res) => {
          const status = decrypt(res.data.status);
          if (status == "success") {
            toast.success(res.data.message);
            getBannerData();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === "failed") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    }
  };
  const handleEdit = (row) => {
    setIsOpen(true);
    setMode("Edit");
    setValue("id", row.id);
    setValue("image_alt", row?.image_alt);
    setValue("image_title", row?.image_title);
    setValue("hn_image_alt", row?.image_alt_hn);
    setValue("hn_image_title", row?.image_title_hn);
    setValue("image_url", `${IMAGE_BASE_URL}` + row?.banner_image);
    setValue("status", row?.status ? { label: "Active", value: true } : { label: "InActive", value: false });
  };
  const handleToggleStatus = (row) => {
    setValue("id", row.id);
    setValue("status", row.status);
    setShowModal(true);
  };
  const confirmStatusChange = () => {
    const data = {
      id: watch("id"),
      status: watch("status"),
    };

    const encryptData = encrypt(data);
    const encryptedData = {
      zero: encryptData,
    };
    updateImgUploadStatusAPI(encryptedData)
      .then((res) => {
        // decrypt data
        const status = decrypt(res.data.status);
        if (status === "success") {
          getBannerData();
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => console.error("Error updating status:", err));

    setShowModal(false);
  };
  return (
    <>
      <Head title={"Manage Photo Gallery"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Photo Gallery"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    reset();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <Row className={`g-gs`}>
            {isOpen && (
              <PreviewAltCard>
                <Form onSubmit={handleSubmit(onFormSubmit)}>
                  <Row className={`g-gs`}>
                    {/*Image Title */}
                    <Col md="4" sm="3" xxl="3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="image_title">
                          {"Image Title"} <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter Image title"}
                            type="text"
                            id="image_title"
                            {...register("image_title", {
                              required: {
                                value: true,
                                message: "Image title is required",
                              },
                              // pattern: {
                              //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                              //   message: "Only alphabets are allowed",
                              // },
                              minLength: {
                                value: 3,
                                message: "Image title must be at least 2 characters long",
                              },
                              maxLength: {
                                value: 50,
                                message: "Image title cannot exceed 50 characters",
                              },
                            })}
                            className="form-control"
                            value={watch("image_title")}
                            onChange={(e) => {
                              // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                              // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                              setValue("image_title", e.target.value);
                              trigger("image_title"); // Trigger validation
                            }}
                            // onInput={(e) => {
                            //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                            // }}
                          />
                          {errors.image_title && <span className="invalid">{errors?.image_title?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/*Image Title HN */}
                    <Col md="4" sm="3" xxl="3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="image_title_hn">
                          {"Image Title Hindi"} <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter Image title in hindi"}
                            type="text"
                            id="image_title_hn"
                            {...register("image_title_hn", {
                              required: {
                                value: true,
                                message: "Image title is required",
                              },
                              // pattern: {
                              //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                              //   message: "Only alphabets are allowed",
                              // },
                              minLength: {
                                value: 3,
                                message: "Image title must be at least 2 characters long",
                              },
                              maxLength: {
                                value: 50,
                                message: "Image title cannot exceed 50 characters",
                              },
                            })}
                            className="form-control"
                            value={watch("image_title_hn")}
                            onChange={(e) => {
                              // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                              // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                              setValue("image_title_hn", e.target.value);
                              trigger("image_title_hn"); // Trigger validation
                            }}
                            // onInput={(e) => {
                            //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                            // }}
                          />
                          {errors.image_title_hn && <span className="invalid">{errors?.image_title_hn?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/*Image Alt */}
                    <Col md="4" sm="3" xxl="3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="image_alt">
                          {"Alt Tag"} <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter Image Alt tag"}
                            type="text"
                            id="image_alt"
                            {...register("image_alt", {
                              required: {
                                value: true,
                                message: "Alt tag is required",
                              },
                              // pattern: {
                              //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                              //   message: "Only alphabets are allowed",
                              // },
                              minLength: {
                                value: 3,
                                message: "Alt tag must be at least 2 characters long",
                              },
                              maxLength: {
                                value: 50,
                                message: "Alt tag cannot exceed 50 characters",
                              },
                            })}
                            className="form-control"
                            value={watch("image_alt")}
                            onChange={(e) => {
                              // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                              // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                              setValue("image_alt", e.target.value);
                              trigger("image_alt"); // Trigger validation
                            }}
                            // onInput={(e) => {
                            //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                            // }}
                          />
                          {errors.image_alt && <span className="invalid">{errors?.image_alt?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/*Image Alt HN */}
                    <Col md="4" sm="3" xxl="3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="image_alt_hn">
                          {"Alt Tag Hindi"} <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter Image Alt tag in hindi"}
                            type="text"
                            id="image_alt_hn"
                            {...register("image_alt_hn", {
                              required: {
                                value: true,
                                message: "Alt tag is required",
                              },
                              // pattern: {
                              //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                              //   message: "Only alphabets are allowed",
                              // },
                              minLength: {
                                value: 3,
                                message: "Alt tag must be at least 2 characters long",
                              },
                              maxLength: {
                                value: 50,
                                message: "Alt tag cannot exceed 50 characters",
                              },
                            })}
                            className="form-control"
                            value={watch("image_alt_hn")}
                            onChange={(e) => {
                              // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                              // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                              setValue("image_alt_hn", e.target.value);
                              trigger("image_alt_hn"); // Trigger validation
                            }}
                            // onInput={(e) => {
                            //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                            // }}
                          />
                          {errors.image_alt_hn && <span className="invalid">{errors?.image_alt_hn?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    <ImageUpload
                      watch={watch}
                      label={"Upload Photo"}
                      errors={errors}
                      register={register}
                      image={"image"}
                      image_url={"image_url"}
                      handleImageChange={handleImageChange}
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                    />
                    <Col md={`2`}>
                      <div className="form-group">
                        <Label className="from-label" htmlFor="status">
                          Status <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            className=""
                            id="status"
                            options={[
                              { value: true, label: "Active" },
                              { value: false, label: "InActive" },
                            ]}
                            {...register("status", {
                              required: "Please select status",
                            })}
                            onChange={handleStatusChange}
                            value={watch("status")}
                          />
                          {errors.status && (
                            <span
                              className="invalid"
                             
                            >
                              {errors?.status?.message}
                            </span>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Col md="2" className={``}>
                    <div className="form-group" style={{ marginTop: "31px" }}>
                      <Button disabled={isLoading} color="primary" size="md">
                        {isLoading ? <Spinner size="sm" color="primary" /> : mode == "Add" ? "Save" : "Update"}
                      </Button>
                    </div>
                  </Col>
                </Form>
              </PreviewAltCard>
            )}
          </Row>
          <MyDataTable data={data} columns={column} title={"Gallery"} isLoading={isLoading} />
        </Block>
        <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
        {/* Confirmation Modal */}
        <ConfirmModal
          isOpen={showModal}
          toggle={() => setShowModal(!showModal)}
          onConfirm={confirmStatusChange}
          status={watch("status")}
        />
      </Content>
    </>
  );
};

export default PhotoGallery;
